import { useQuery, useMutation } from '@tanstack/react-query';

import { getFullListStrategiesAdministration, changeStrategy } from '../../../../api';

export const useStrategies = () =>
  useQuery({ queryKey: ['getFullListStrategiesAdministration'], queryFn: getFullListStrategiesAdministration });

export const useChangeState = () => useMutation({ mutationKey: ['changeStrategy'], mutationFn: changeStrategy });
